import React from 'react';
function SingleLine({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M9 4c2 0 3 1.5 3 3m0 0v10m0-10v10m0-10c0-2.4 2-3 3-3m-3 13c0 2.4-2 3-3 3m3-3c0 2.4 2 3 3 3" />
      <path strokeLinecap="round" d="M10.5 12h3" />
    </svg>
  );
}

export default SingleLine;
